(async () => {
    const selectCountry = document.getElementById('country');
    const selectProfileCountry = document.getElementById('profileCountry');
    const selects = [selectCountry, selectProfileCountry].filter(Boolean);

    if (!selects.length) return;

    const firstSelect = selects[0];
    const wpLocale = (firstSelect.getAttribute('data-locale') || navigator.language || 'en').replace('_','-');
    const lang = wpLocale.split('-')[0];

    // 1) Ottieni elenco ISO 3166-1 completo
    let codes = [];
    if (Intl.supportedValuesOf) {
        try {
            codes = Intl.supportedValuesOf('region'); // ~250 paesi
        } catch(e) {}
    }

    // 2) Fallback completo se il browser non supporta supportedValuesOf
    if (!codes.length) {
        const res = await fetch('https://cdn.jsdelivr.net/gh/lukes/ISO-3166-Countries-with-Regional-Codes@master/all/all.json');
        const data = await res.json();
        codes = data.map(c => c['alpha-2']);
    }

    // 3) Traduttore nomi paesi
    let dn;
    try {
        dn = new Intl.DisplayNames([wpLocale, lang, 'en'], { type: 'region' });
    } catch(e) {
        dn = { of: code => code };
    }

    // 4) Costruisci lista {code,label} e ordina alfabeticamente
    const items = codes
        .map(code => ({ code, label: dn.of(code) || code }))
        .filter(x => x.label && !/^\d+$/.test(x.label))
        .sort((a,b) => a.label.localeCompare(b.label, wpLocale));

    // 5) Popola ogni select
    for (const select of selects) {
        const isProfile = select.id === 'profileCountry';
        const preselectedValue = isProfile ? (select.getAttribute('data-value') || '').toUpperCase() : '';

        const frag = document.createDocumentFragment();
        for (const {code, label} of items) {
            const opt = document.createElement('option');
            opt.value = code;
            opt.textContent = label;
            if (isProfile) {
                if (code === preselectedValue) opt.selected = true;
            } else if (code === 'IT') {
                opt.selected = true;
            }
            frag.appendChild(opt);
        }

        if (isProfile) {
            select.appendChild(frag);
            if (preselectedValue) select.value = preselectedValue;
        } else {
            select.innerHTML = '';
            select.appendChild(frag);
        }
    }
})();